import React from 'react';
import { PROCESS_STEPS, STATS } from '../data/mock';

const ProcessHeader = () => (
  <div className="text-center mb-16">
    <p className="text-[#1AB6FF] font-semibold uppercase tracking-[0.2em] text-xs mb-3">Our Process</p>
    <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-tight">
      From Audit to <span className="gradient-text">Autopilot.</span>
    </h2>
    <p className="mt-5 text-white/55 max-w-2xl mx-auto">
      A proven 6-step rollout that takes your operations from manual to AI-augmented in weeks, not quarters.
    </p>
  </div>
);

const DesktopStep = ({ step, index }) => (
  <div className="flex flex-col items-center text-center">
    <div className="relative w-10 h-10 rounded-full border-2 border-[#1AB6FF] bg-[#04070d] flex items-center justify-center">
      <span
        className="w-3 h-3 rounded-full bg-[#1AB6FF] dot-pulse"
        style={{ animationDelay: `${index * 0.3}s` }}
      />
    </div>
    <div className="w-px h-10 bg-gradient-to-b from-[#1AB6FF]/50 to-transparent" />
    <p className="text-white/55 text-xs uppercase tracking-wider">{step.step}</p>
    <p className="mt-1 font-display font-semibold text-white">{step.title}</p>
  </div>
);

const DesktopTimeline = () => (
  <div className="hidden lg:block relative">
    <div className="absolute top-5 left-[6%] right-[6%] h-px bg-gradient-to-r from-transparent via-[#1AB6FF]/40 to-transparent" />
    <div className="grid grid-cols-6 gap-4">
      {PROCESS_STEPS.map((s, i) => (
        <DesktopStep key={s.step} step={s} index={i} />
      ))}
    </div>
  </div>
);

const MobileStep = ({ step }) => (
  <div className="card-tech rounded-xl p-5">
    <p className="text-[#1AB6FF] text-xs uppercase tracking-wider">{step.step}</p>
    <p className="mt-2 font-display font-semibold text-white text-lg">{step.title}</p>
  </div>
);

const MobileSteps = () => (
  <div className="lg:hidden grid sm:grid-cols-2 gap-5">
    {PROCESS_STEPS.map((s) => (
      <MobileStep key={s.step} step={s} />
    ))}
  </div>
);

const StatCard = ({ stat }) => (
  <div className="card-tech rounded-xl p-6 text-center">
    <p className="font-display font-bold text-3xl md:text-4xl gradient-text">{stat.value}</p>
    <p className="mt-2 text-white/55 text-xs uppercase tracking-wider">{stat.label}</p>
  </div>
);

const StatsGrid = () => (
  <div className="mt-24 grid grid-cols-2 lg:grid-cols-4 gap-5">
    {STATS.map((stat) => (
      <StatCard key={stat.label} stat={stat} />
    ))}
  </div>
);

const ProcessSteps = () => (
  <section className="relative py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <ProcessHeader />
      <DesktopTimeline />
      <MobileSteps />
      <StatsGrid />
    </div>
  </section>
);

export default ProcessSteps;
